import { TItem } from '@libs/types';
import { numberFormat } from '@libs/utils';
import { TBalance, TConsumerItem } from '../../../types/data';

const currencyIconMap: Map<string, string> = new Map();
currencyIconMap.set('eur', '€');
currencyIconMap.set('gbp', '£');
currencyIconMap.set('usd', '$');
currencyIconMap.set('mxn', '$');
currencyIconMap.set('cny', '¥');
currencyIconMap.set('uah', '₴');
currencyIconMap.set('kzt', '₸');
export const convertBalanceInToListItem = (balances: Array<TBalance>, selectedId: string): Array<TItem> => {
    const items: Array<TItem> = [];
    if (Array.isArray(balances)) {
        balances.forEach((balance) => {
            const item: TConsumerItem = {
                id: balance?.id,
                title: '' + numberFormat(balance?.balance),
                value: balance?.id,
                iconName: `ic_${balance?.iso?.toLowerCase()}`,
                defaultIconName: 'ic_default_currency',
                iconVariant: 'circle',
                iconHierarchy: 'primary',
                subtitle: balance?.name,
                selected: balance?.id === selectedId,
            };
            items.push(item);
        });
    }
    return items;
};

export const getIconForCurrencyIso = (iso?: string): string | undefined => (iso ? currencyIconMap.get((iso ?? '').toLowerCase()) : undefined);
